import { getContent } from "@/api/modules/content";

const ContentModel = function(name, title, body) {
    this.name = name;
    this.title = title;
    this.body = body;
};

export class ContentNotFoundError extends Error {
    constructor(message) {
        super(message);
        this.name = "ContentNotFoundError";
    }
}

export const state = {
    contentPages: [],
    startupMessageShownStatus: false
};

export const mutations = {
    setContentPage: (state, { key, model }) => {
        state.contentPages = {
            ...state.contentPages,
            [key]: model
        };
    },
    setStartupMessageShownStatus: state => {
        state.startupMessageShownStatus = true;
    }
};

export const getters = {
    startupMessageHasBeenShown: state => {
        return state.startupMessageShownStatus;
    }
};

export const actions = {
    getContentPage: async (context, { identifier, languageCode }) => {
        const key = `${identifier}.${languageCode}`;

        if (context.state.contentPages[key])
            return Promise.resolve(context.state.contentPages[key]);

        const response = await getContent(identifier, languageCode);
        if (!response.ok) throw new Error(JSON.stringify(response));

        if (
            !response.responseBody.contents ||
            !response.responseBody.contents.length
        ) {
            throw new ContentNotFoundError(
                "content " + identifier + " not found"
            );
        }

        const content = response.responseBody.contents[0];

        if (!content.type === "Page") {
            throw new ContentNotFoundError(
                "content " + identifier + " is not a page"
            );
        }

        const model = new ContentModel(
            identifier,
            content.page.title,
            content.page.body
        );

        context.commit("setContentPage", { key, model });

        return model;
    }
};
